module.exports = __webpack_public_path__ + "static/media/test14_1.9626afa6.png";